import * as React from 'react';
import '@styles/pages/tab2.scss';
import { StageDefault, StageCurrent } from '@/context.ts';
import { fetch, StageRankRsp, AreaInfo, RankItem } from '@/fetch.ts';
import RankHeader from '@hook/public/rankHeader.tsx';
import Page from '@hook/public/page.tsx';
import AnchorItem from '@hook/public/anchorItem.tsx';
import NoneData from '@hook/public/none.tsx';
import defaultAvatar from '@images/default.png';
interface Props extends AreaInfo {
  iArea: number,
}
const { useState, useEffect, useContext } = React;

const tab2Rank4: React.FC<Props> = props => {
  const {tabCurrent} = useContext(StageDefault);
  const {current} = useContext(StageCurrent);
  const [list, List] = useState<RankItem[]>([]);
  const [showList, ShowList] = useState<RankItem[]>([]);
  const pageChange = (index: number): void => {
    ShowList(list.slice((index) * 10, (index + 1) * 10 >= list.length ? list.length : (index + 1) * 10));
  }
  useEffect(() => {
    /* 获取分区榜单 */
    fetch.getStageRank(
      {
        iMatchId: tabCurrent,
        iStage: current,
        iArea: props.iArea,
        iRevive: 0,
        lPid: 0,
      },
    )
      .then((rsp: StageRankRsp) => {
        List(rsp.vRank.value.slice(0, 50));
        ShowList(rsp.vRank.value.length > 10 ? rsp.vRank.value.slice(0, 10) : rsp.vRank.value);
      })
  }, [current, tabCurrent])
  return (
    <div className='tab2Rank4' id={'area' + props.iArea}>
      <h1>{props.sName}</h1>
      <div className='chamption'>
        {
          showList.length !== 0 && showList[0].iRank === 1 &&
          <>
            <div className='avatar'>
              <img
                title={showList[0].sNickName}
                src={showList[0].sLogoUrl}
                onError={(event: any): void => {
                  event.target.onerror = null;
                  event.target.src = defaultAvatar;
                }}
                onClick={(event: any) => {
                  window.open('https://m.huya.com/' + showList[0].tJump.iRoomId, '_blank');
                }}
              />
              <i className='label'>分区冠军</i>
            </div>
            <h3>
              <p>{showList[0].sNickName}</p>
              {
                showList[0].tJump.bLive &&
                <i></i>
              }
            </h3>
            <h4>{showList[0].lScore}</h4>
          </>
        }
      </div>
      <RankHeader
        width={300}
        color='#519ff7'
        prev='排名'
        mid='主播昵称'
        next='热度'
      />
      <div className='tab2Rank4List'>
        {
          showList.length === 0 ?
            <NoneData text={'暂无数据'} />
            :
            showList.map((item: RankItem) => {
              if (item.iRank === 1) {
                return '';
              }
              return (
                <AnchorItem
                  key={item.lUid}
                  width={306}
                  {...item}
                  revive={false}
                  chamption={true}
                />
              )
            })
        }
      </div>
      <Page
        pageLen={list.length % 10 === 0 ? list.length / 10 : Math.floor(list.length / 10) + 1}
        setPageIndex={pageChange}
      />
    </div>
  )
}
export default tab2Rank4;